module.exports = __webpack_public_path__ + "static/media/73.9dc8c8ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/73.jpg
// module id = 1011
// module chunks = 0